import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { UploadAttachResponseDTO } from "./models";

export class UploadAttachApi {
  static uploadAttach = async (file: File, fileName: string, type: string) => {
    let formData = new FormData();
    formData.append("file", file, fileName);
    formData.append("type", type);
    formData.append("isFileName", "true");
    const response = GbApiRequestService.post("file", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return await withSchemaValidation(response, UploadAttachResponseDTO);
  };
}
